
import Vue from 'vue'
import axios from 'axios'
import { Prop, Component } from 'vue-property-decorator'
import { Job, TranslationActivity, TranslationActivityFile } from '../../global/models'
import { downloadFile } from '../../global/functions/util'
import TranslationSourceModal from './TranslationSourceModal.vue'

@Component({
  components: { TranslationSourceModal }
})
export default class FullTranslationActivityView extends Vue {
  @Prop({ type: Object, required: true })
  private readonly job!: Job

  @Prop({ type: Object, required: true })
  private readonly activity!: TranslationActivity

  translationFiles: TranslationActivityFile[] = []

  get sourceModal() {
    return this.$refs.sourceModal as TranslationSourceModal
  }

  mounted() {
    this.getData()
  }

  async getData() {
    const response = await axios.get<TranslationActivityFile[]>(`/jobs/${this.activity.jobId}/activities/${this.activity.id}/translations`)
    this.translationFiles = response.data
  }

  viewDocument() {
    this.sourceModal.open(this.activity)
  }

  downloadTranslationFile(file: TranslationActivityFile) {
    downloadFile(`${axios.defaults.baseURL}/jobs/${this.activity.jobId}/activities/${this.activity.id}/translations/${file.id}/download`)
  }
}
